import React, { createContext, useContext, useState } from 'react';

interface ContactosDistribuidor {
    clienteId: number;
    clienteDistribuidorId: number;
    contactos: any[]
}

interface ContactosDistribuidorContextProps {
    contactosDistribuidor: ContactosDistribuidor;
    setContactosDistribuidor: React.Dispatch<React.SetStateAction<ContactosDistribuidor>>;
}


const ContactosDistribuidorContext = createContext<ContactosDistribuidorContextProps | undefined>(undefined);

export const ContactosDistribuidorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [contactosDistribuidor, setContactosDistribuidor] = useState<ContactosDistribuidor>({ clienteId: 0, clienteDistribuidorId: 0 , contactos: [] });

    return (
        <ContactosDistribuidorContext.Provider value={{ contactosDistribuidor, setContactosDistribuidor }}>
            {children}
        </ContactosDistribuidorContext.Provider>
    );
};

// Hook
export const useContactosDistribuidor = () => {
    const context = useContext(ContactosDistribuidorContext);
    if (!context) {
        throw new Error("useContactosDistribuidor debe ser usado dentro de un ContactosDistribuidorProvider");
    }
    return context;
};
